var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background-loading"},[_c('div',{staticClass:"image",style:(("background-image: url(/loading/step-" + _vm.state + ".svg)"))})])}
var staticRenderFns = []

export { render, staticRenderFns }